function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import { font, padding, getSpacing, getDisplay, mediaMinWidth } from '../../utils/helpers';
var ModalText = styled.p(_templateObject(), function (_ref) {
  var _extends2;

  var theme = _ref.theme;
  var breakpoints = theme.breakpoints,
      colors = theme.colors,
      text = theme.text;
  var shared = text.shared;
  return _extends({
    margin: 0,
    color: colors.black
  }, font(_extends({}, shared.normal, text.lead.xsmall)), padding(text.lead.xsmall), (_extends2 = {
    strong: _extends({}, font(shared.bold))
  }, _extends2[mediaMinWidth(breakpoints.small)] = _extends({}, font(text.lead.small), padding(text.lead.small)), _extends2[mediaMinWidth(breakpoints.medium)] = _extends({}, font(text.standard.small), padding(text.standard.small)), _extends2[mediaMinWidth(breakpoints.xlarge)] = _extends({}, font(text.standard.xlarge), padding(text.standard.xlarge)), _extends2));
}, getSpacing, getDisplay);
export default ModalText;